module.exports = __webpack_public_path__ + "static/media/airbtics_pro_au_cover.a4ef7194.jpg";